import { renderDate } from '../utility/personTabGridHelper';

export const VEHICLE_REGISTRATION_COLUMNS = [
  { field: 'VehicleID', headerName: 'Vehicle ID', width: 160 },
  { field: 'PlateNumber', headerName: 'Plate Number', width: 160 },
  { field: 'PlateState', headerName: 'Plate State', width: 140 },
  {
    field: 'PlateExpiration',
    headerName: 'Plate Expiration',
    width: 180,
    valueFormatter: renderDate,
  },
  { field: 'VIN', headerName: 'VIN', width: 150 },
  { field: 'PartyID', headerName: 'Party ID', width: 150 },
  { field: 'PlateType', headerName: 'Plate Type', width: 150 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
